import Flickity from 'flickity';
import 'flickity-as-nav-for';
import { throttle } from 'throttle-debounce';
import { cursorNavigation } from '../base/carousel';

export function init() {
	const elems = Array.from(document.querySelectorAll('.js-carousel'));
	elems.forEach(e => create(e));
}

const configs = {
	defaults: {
		contain: true,
		groupCells: false,
		pageDots: false,
		prevNextButtons: false,
		freeScroll: true,
	},

	infinite: {
		cellAlign: 'center',
		wrapAround: true,
		freeScroll: true,
	},

	left: {
		cellAlign: 'left',
		wrapAround: false,
	},
};

function create(element) {
	let cursor;
	let carousel;
	let behavior;

	const carouselElement = element.querySelector('.js-carousel-items');
	const cells = Array.from(carouselElement.children);

	update();

	window.addEventListener('resize', throttle(1000, update));

	function update() {
		if (carousel) {
			carousel.destroy();
			carousel = undefined;
		}

		if (cursor) {
			cursor.destroy();
			cursor = undefined;
		}

		if (element.scrollWidth <= element.clientWidth) {
			return;
		}

		const cellWidths = cells.map(element => element.clientWidth);
		const minWidth = Math.min(...cellWidths);

		if (element.scrollWidth <= element.clientWidth + minWidth) {
			behavior = 'left';
		} else {
			behavior = 'infinite';
		}

		carousel = new Flickity(carouselElement, {
			...configs[behavior],
			...configs['defaults'],
		});

		cursor = cursorNavigation(carousel);
	}

	return {
		carousel,
	};
}
